import Breadcrumbs from "../atoms/Breadcrumbs";
import SearchAnchorNav from "../organisms/SearchAnchorNav";
import Grid from "../atoms/Grid";
import SearchCard from "../molecules/SearchCard";

export default function SearchResultsTemplate({
  products = [],
  services = [],
  business_segment = [],
  news = [],
  pages = [],
  term,
  translations,
  locale,
  defaultLocale
}) {
  const breadcrumbs = [
    {
      name: translations['home'],
      href: "/",
    },
    {
      name: translations['search'],
      href: "/search",
    },
  ];
  const productsAndServices = [
    ...products.map((product) => ({ ...product, type: "product" })),
    ...(services.map((service) => ({ ...service, type: "service" })) || []),
  ];

  const limitContent = (content) => {
    if (content && content.length > 140) {
      return content.slice(0, 140) + "...";
    }
    return content;
  };

  return (
    <>
      <div className="relative bg-gray-200 container-custom pt-120 pb-20 1024:pt-190 1024:pb-40">
        <Breadcrumbs breadcrumbs={breadcrumbs} locale={locale} defaultLocale={defaultLocale} />
        <div className="flex flex-col">
          <h1 className="text-xl 640:text-xxl 1024:text-xxxl font-medium">
            {translations['search_results_for']} <span className="italic">{term}</span>
          </h1>
        </div>
      </div>
      <SearchAnchorNav
        productsAndServices={productsAndServices}
        businessSegment={business_segment}
        news={news}
        pages={pages}
        translations={translations}
      />
      {/* Products and services */}
      {productsAndServices.length ? (
        <div id="products" className="container-custom pt-40 640:pt-80">
          <div className="flex flex-col gap-y-20">
            <h2 className="text-l 1024:text-xl font-medium leading-120">
            {translations['products_services']}
            </h2>
            <Grid extraClass="!gap-y-0">
              {productsAndServices.map((item, index) => (
                <SearchCard
                  translations={translations}
                  key={index}
                  title={item.title}
                  text={limitContent(item.description)}
                  href={
                    item.type == "product"
                      ? `/products/${item.slug}`
                      : `/services/${item.slug}`
                  }
                />
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* Business Segments */}
      {business_segment.length ? (
        <div id="business" className="container-custom pt-40 640:pt-80">
          <div className="flex flex-col gap-y-20">
            <h2 className="text-l 1024:text-xl font-medium leading-120">
            {translations['business_segments']}
            </h2>
            <Grid extraClass="!gap-y-0">
              {business_segment.map((item, index) => (
                <SearchCard
                  key={index}
                  translations={translations}
                  title={item.title}
                  text={limitContent(item.content)}
                  href={`/business-segments/${item.slug}`}
                />
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* News & Media */}
      {news.length ? (
        <div id="news" className="container-custom pt-40 640:pt-80">
          <div className="flex flex-col gap-y-20">
            <h2 className="text-l 1024:text-xl font-medium leading-120">
            {translations['news_and_media']}
            </h2>
            <Grid extraClass="!gap-y-0">
              {news.map((item, index) => (
                <SearchCard
                  translations={translations}
                  key={index}
                  title={item.title}
                  text={limitContent(item.content)}
                  href={`/news/${item.slug}`}
                />
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <></>
      )}

      {/* Pages */}
      {pages.length ? (
        <div id="pages" className="container-custom pt-40 640:pt-80">
          <div className="flex flex-col gap-y-20">
            <h2 className="text-l 1024:text-xl font-medium leading-120">
              {translations['pages']}
            </h2>
            <Grid extraClass="!gap-y-0">
              {pages.map((item, index) => (
                <SearchCard
                  translations={translations}
                  key={index}
                  title={item.title}
                  text={limitContent(item.content)}
                  href={`/${item.slug}`}
                  length={pages.length}
                />
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
